import React, { useEffect, useState, useCallback } from "react";
import { Gamepad2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n";
import { toast } from "sonner";
import DrawCard from "../components/DrawCard";
import { CardSkeletonList, EmptyState } from "../components/Common";
import { MiniGamesGrid } from "../components/MiniGamesGrid";

export default function RoyalPlay() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [favs, setFavs] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/games");
      setGames(data);
    } catch {}
    setLoading(false);
  }, []);

  const loadFavs = useCallback(async () => {
    if (!user) return;
    try { const { data } = await api.get("/favourites"); setFavs(data); } catch {}
  }, [user]);

  useEffect(() => { load(); loadFavs(); }, [load, loadFavs]);

  const toggleFav = async (gameId) => {
    if (!user) { toast.info("Login to save favourites"); return; }
    try {
      const { data } = await api.post(`/favourites/${gameId}`);
      setFavs((p) => (data.favourite ? [...p, gameId] : p.filter((f) => f !== gameId)));
    } catch {}
  };

  return (
    <div className="space-y-4">
      <div className="rl-card p-4 flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl rl-gold-bg flex items-center justify-center"><Gamepad2 className="w-6 h-6" /></div>
        <div>
          <h1 className="font-display font-black text-slate-900 text-xl">{t("royal_play_arena")}</h1>
          <p className="text-xs text-slate-500">{t("royal_play_sub")}</p>
        </div>
      </div>

      <MiniGamesGrid />

      {loading ? <CardSkeletonList count={5} /> : games.length === 0 ? (
        <EmptyState icon={Gamepad2} title={t("no_games_available")} subtitle={t("check_back_soon")} />
      ) : (
        <div className="space-y-3">
          {games.map((g) => <DrawCard key={g.id} game={g} isFav={favs.includes(g.id)} onToggleFav={toggleFav} />)}
        </div>
      )}
    </div>
  );
}
